// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TjwjM","label":"styles_label__1fI_J"};